import DEVICE_LIST from '../../graphql/device/list.graphql'
import DEVICE_CREATE from '../../graphql/device/create.graphql'
import DEVICE_UPDATE from '../../graphql/device/update.graphql'
import DEVICE_DELETE from '../../graphql/device/delete.graphql'

import {processMutation, processQuery, genericMutations} from '../utils'

export default {
    namespaced: true,
    state: {
        list: [],
        detail: null,
    },

    mutations: {
        ...genericMutations('list', 'detail'),
    },

    actions: {
        async list({commit}) {
            return await processQuery(this, DEVICE_LIST, 'device.list', {}, 'device/setList')
        },

        async create({commit}, data) {
            if (data.user) {
                data.user = parseInt(data.user)
            }
            return await processMutation(this, DEVICE_CREATE, 'device.create', data)
        },

        async update({commit}, data) {
            if (data.user) {
                data = {...data, user: parseInt(data.user.id)}
            }
            return await processMutation(this, DEVICE_UPDATE, 'device.update', data)
        },

        async delete({commit}, id) {
            return await processMutation(this, DEVICE_DELETE, 'device.delete', {id: id})
        },
    }
}